<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerProductAccountPeriodList' }">合作产品路径期间</el-breadcrumb-item>
                <el-breadcrumb-item>合作产品路径期间{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                    class="is-required"
                                    v-show="
                                        !in_array(item.prop, ['business_unit_rid', 'performance_basis_code']) ||
                                        (item.prop == 'business_unit_rid' && formData['type_code'] == 1) ||
                                        (item.prop == 'performance_basis_code' && formData['type_code'] == 2)
                                    "
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown-mul'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                    v-show="item.prop == 'province_sign' && formData['type_code'] == 1"
                                >
                                    <vDropdownMul
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params']"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdownMul>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import vDropdownMul from '@/components/common/dropdown/dropdownMul.vue';

export default {
    name: 'partnerProductAccountPeriodEdit',
    components: {
        vSearchSelect,
        vDropdownMul
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.ppa_rid = this.$route.query.ppa_rid;
            this.data.type_code = 1;
        }
    },
    methods: {
        in_array,
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                business_unit_rid: {
                    request_uri: 'dropdownBusinessUnits',
                    title: '业务单元',
                    ref: 'business_unit_rid_ref',
                    type: 'dropdown',
                    select_value: 'rid'
                },
                performance_basis_code: {
                    request_uri: 'dropdownPerformanceBasis',
                    title: '绩效类型',
                    ref: 'performance_basis_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                ppa_rid: {
                    request_uri: 'dropdownPartnerProductAccount',
                    title: '合作产品路径',
                    ref: 'ppa_rid_ref',
                    type: 'dropdown',
                    select_value: 'rid',
                    display_name: 'code'
                },
                type_code: {
                    request_uri: 'dropdownPpaType',
                    title: '类型',
                    ref: 'type_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                start_date: {
                    title: '开始日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'start_date_ref',
                    type: 'date'
                },
                end_date: {
                    title: '结束日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'end_date_ref',
                    type: 'date'
                },
                province_sign: {
                    request_uri: 'dropdownProvinceSign',
                    title: '省份',
                    ref: 'province_sign_ref',
                    type: 'dropdown-mul',
                    tips: '可多选，如果新增时不填，默认填PPA的省份',
                    select_value: 'value'
                }
            };
        },
        initFormRule() {
            this.rules = {
                start_date: [{ required: true, message: '请输入开始日期', trigger: 'blur' }],
                end_date: [{ required: true, message: '请输入结束日期', trigger: 'blur' }],
                type_code: [{ required: true, message: '请选择类型', trigger: 'blur' }],
                remark: [{ required: false, message: '请输入备注', trigger: 'blur' }],
                performance_basis_code: [{ required: false, message: '请选择绩效类型', trigger: 'blur' }],
                business_unit_rid: [{ required: false, message: '请选择业务单元', trigger: 'blur' }],
                province_sign: [{ required: false, message: '省份', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id || '';
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                ppa_rid: this.data.ppa_rid || this.$route.query.ppa_rid,
                start_date: this.data.start_date || '',
                end_date: this.data.end_date || '',
                business_unit_rid: this.data.business_unit_rid || '',
                performance_basis_code: this.data.performance_basis_code || '1',
                type_code: this.data.type_code || 1,
                remark: this.data.remark || '',
                province_sign: this.data.province_sign || []
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).partner_product_account_period;

            processColDataToEdit(
                temp,
                this,
                {
                    white: ['start_date', 'end_date', 'partner_name', 'product_name', 'account_name', 'remark']
                },
                {
                    type: 'type_code',
                    business_unit_code: 'business_unit_rid',
                    performance_basis: 'performance_basis_code',
                    ppa_code: 'ppa_rid',
                    province_sign_label: 'province_sign'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                if (this.$route.query.ppa_rid) {
                    this.$router.push({ path: '/partnerProductAccountDetail?id=' + this.$route.query.ppa_rid });
                } else {
                    this.$router.push({ path: '/partnerProductAccountPeriodList' });
                }
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .partnerProductAccountPeriodDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.data.province_sign = this.data.province_sign_array || [];
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            if (this.formData.type_code == 1) {
                if (this.formData.business_unit_rid == '') {
                    this.$message({
                        message: '当类型为业务单元时，业务单元必填',
                        type: 'error'
                    });
                    return false;
                }
            } else if (this.formData.type_code == 2) {
                if (this.formData.performance_basis_code == '') {
                    this.$message({
                        message: '当类型为绩效类型时，绩效类型必填',
                        type: 'error'
                    });
                    return false;
                }
            }

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'partnerProductAccountPeriodUpdate';
            } else {
                uri = 'partnerProductAccountPeriodInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    this.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>